import { TravelTypes } from '../constants';

const getTripItineraries = (trip) => {
  const itineraries = [];
  if (!trip) return itineraries;
  if (trip.cruiseItinerary) {
    itineraries.push({
      ...trip.cruiseItinerary,
      mode: TravelTypes.cruise,
    });
  }
  if (trip.flightItinerary) {
    itineraries.push({
      ...trip.flightItinerary,
      mode: TravelTypes.flight,
    });
  }
  if (trip.hotelItineraries && Object.keys(trip.hotelItineraries).length > 0) {
    Object.values(trip.hotelItineraries).forEach((itinerary) => {
      itineraries.push({
        ...itinerary,
        mode: TravelTypes.hotel,
      });
    });
  }
  if (trip.tourItineraries && trip.tourItineraries.length) {
    trip.tourItineraries.forEach((it) => {
      itineraries.push({
        ...it,
        mode: TravelTypes.tour,
      });
    });
  }
  if (trip.rentalCarItineraries && Object.values(trip.rentalCarItineraries).length) {
    Object.values(trip.rentalCarItineraries).forEach((it) => {
      itineraries.push({
        ...it,
        mode: TravelTypes.carrental,
      });
    });
  }
  if (trip.insuranceItinerary) {
    itineraries.push({
      ...trip.insuranceItinerary,
      mode: TravelTypes.insurance,
    });
  }
  return itineraries;
};

export default getTripItineraries;
